module.exports = __webpack_public_path__ + "img/hdtool_ricerca3.d78ec5a0.png";